import React, { useState } from "react"
import { slide as Slide } from "react-burger-menu"
import { Link } from "gatsby"
import { lighten } from "polished"
import styled from "styled-components"

import logo from "../assets/images/logo.png"

const StyledMenu = styled.div`
  /* Position and sizing of burger button */
  .bm-burger-button {
    position: fixed;
    width: 36px;
    height: 30px;
    right: 1rem;
    top: ${({ pageScrolled }) => (pageScrolled ? "0.75rem" : "1.25rem")};
    transition: all 0.4s ease-in-out;
    @media only screen and (min-width: 500px) {
      right: 2rem;
      top: ${({ pageScrolled }) => (pageScrolled ? "1rem" : "1.5rem")};
    }
  }

  /* Color/shape of burger icon bars */
  .bm-burger-bars {
    background: #fff;
  }

  /* Color/shape of burger icon bars on hover*/
  .bm-burger-bars-hover {
    background: #fff;
  }

  /* Position and sizing of clickable cross button */
  .bm-cross-button {
    height: 24px;
    width: 24px;
  }

  /* Color/shape of close button cross */
  .bm-cross {
    background: #bdc3c7;
  }

  /*
    Sidebar wrapper styles
    Note: Beware of modifying this element as it can break the animations - you should not need to touch it in most cases
    */
  .bm-menu-wrap {
    position: fixed;
    height: 100%;
    top: 0;
  }

  /* General sidebar styles */
  .bm-menu {
    background: ${({ theme }) => lighten(0.1, theme.colors.obsidian)};
    padding: 2.5rem 1.5rem 0;
    top: 0;
    a {
      color: #fff;
      margin-bottom: 0.5rem;
      text-transform: uppercase;
    }
    .logo {
      margin-bottom: 1rem;
      a {
        display: block;
      }
      img {
        max-width: 100%;
        display: block;
      }
    }
  }

  /* Morph shape necessary with bubble or elastic */
  .bm-morph-shape {
    fill: #373a47;
  }

  /* Wrapper for item list */
  .bm-item-list {
    color: #b8b7ad;
    padding: 0.8em;
  }

  /* Individual item */
  .bm-item {
    display: inline-block;
  }

  /* Styling of overlay */
  .bm-overlay {
    background: rgba(0, 0, 0, 0.3);
  }
`

const Menu = ({ siteTitle, pageScrolled }) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <StyledMenu pageScrolled={pageScrolled}>
      <Slide
        pageWrapId="page-wrap"
        isOpen={isOpen}
        onStateChange={state => setIsOpen(state.isOpen)}
      >
        <div className="logo">
          <Link to="/">
            <img src={logo} alt={siteTitle} />
          </Link>
        </div>
        <Link to="/">Home</Link>
        <Link onClick={() => setIsOpen(false)} to="/#features">
          Features
        </Link>
        <Link to="/pricing">Pricing</Link>
        <Link to="/about">About</Link>
        <Link to="/blog">Blog</Link>
        <Link to="/contact">Contact</Link>
      </Slide>
    </StyledMenu>
  )
}

export default Menu
